import Web3 from 'web3';
import BuyContractABI from '@/contracts/BuyContract.json';
import USDTContractABI from '@/contracts/USDTContract.json';
import { getCurrentInstance } from 'vue';
import i18n from '@/plugins/i18n';
import { getGlobalConfig } from '@/api/apiService';
import store from '@/store';

class WalletConnect {

    buyContract = null;
    usdtContract = null;
    contractAddress = '';
    usdtContractAddress = '';
    walletAddress = '';
    storeThreshold = 0;
    isAgentRoute = false;
    isConnected = false;
    constructor(router, setLoading) {
        this.router = router;
        this.setLoading = setLoading; // Function to update loading state
        this.isConnected = false;
        console.log(this.router, this.router.getRoutes(), this.router.currentRoute.value, "App router");
        this.isAgentRoute = this.router.currentRoute.value.name.includes('agent');
        this.isRequestPending = false; // Flag to track pending requests
        if(window.VueApp){
            this.toast = window.VueApp.config.globalProperties.$toast;
            this.t = window.VueApp.config.globalProperties.$t;
            this.store = window.VueApp.config.globalProperties.$store;
        }else {
            const { appContext } = getCurrentInstance();
            console.log(appContext, "appContext");
            this.toast = appContext.app.config.globalProperties.$toast;
            this.t = i18n.global.t;
            this.store = store;
        }
        this.eventbus = window.VueApp.config.globalProperties.$eventBus;
        this.targetNetwork = process.env.NODE_ENV === 'production' ? '56' : '97'; // 主网或测试网
        if(localStorage.getItem('targetNetwork')) {
            this.targetNetwork = parseInt(localStorage.getItem('targetNetwork'));
        }
        console.log("targetNetwork", this.targetNetwork, process.env.NODE_ENV);
        // this.targetNetwork = 56;
        this.networkParams = {
            '56': {
                chainId: '0x38',
                chainName: this.t('network.mainnet'),
                nativeCurrency: {
                    name: 'BNB',
                    symbol: 'BNB',
                    decimals: 18,
                },
                rpcUrls: ['https://bsc-dataseed.binance.org/'],
                blockExplorerUrls: ['https://bscscan.com'],
            },
            '97': {
                chainId: '0x61',
                chainName: this.t('network.testnet'),
                nativeCurrency: {
                    name: 'BNB',
                    symbol: 'BNB',
                    decimals: 18,
                },
                rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
                blockExplorerUrls: ['https://testnet.bscscan.com'],
            },
        };
        // window.ethereum.enable().then(()=> {
            this.web3 = new Web3(window.ethereum);
            // Fetch contract addresses from Vuex
            this.store.subscribe((mutation, state) => {
                if(mutation.type === 'SET_GLOBAL_CONFIG') {
                    this.contractAddress = state.contractAddress;
                    this.usdtContractAddress = state.usdtContractAddress;
                    this.storeThreshold = state.storeThreshold;
                    // Initialize contract instances
                    this.buyContract = new this.web3.eth.Contract(BuyContractABI, this.contractAddress);
                    this.usdtContract = new this.web3.eth.Contract(USDTContractABI, this.usdtContractAddress);
                    this.onContractsInitialized();
                }
            });
            if(this.contractAddress=='' || this.usdtContractAddress=='' || this.storeThreshold==0 || this.contractAddress==null || this.usdtContractAddress==null || this.storeThreshold==null) {
                if(localStorage.getItem('contractAddress') && localStorage.getItem('usdtContractAddress') && localStorage.getItem('storeThreshold')) {
                    this.contractAddress = localStorage.getItem('contractAddress');
                    this.usdtContractAddress = localStorage.getItem('usdtContractAddress');
                    this.storeThreshold = localStorage.getItem('storeThreshold');
                    this.buyContract = new this.web3.eth.Contract(BuyContractABI, this.contractAddress);
                    this.usdtContract = new this.web3.eth.Contract(USDTContractABI, this.usdtContractAddress);
                    this.onContractsInitialized();
                } else {
                    this.toast.showMarkLoading();
                    getGlobalConfig().then(config=> {
                        this.store.dispatch('setGlobalConfig', config);
                        this.toast.hideMarkLoading();
                    });
                }
            }
            this.store.state.chainId = this.targetNetwork;
            this.init();

            // Listen for route changes
            // this.router.beforeEach((to, from, next) => {
            //     console.log(to.name, "to.name", from, "from", to.name.includes('agent'));
            //     if(to.name.includes('agent')){
            //         this.isAgentRoute = true;
            //     }else{
            //         this.isAgentRoute = false;
            //     }
            //     this.init(); // Re-initialize on route change
            //     next();
            // });
        // });
    }
    onContractsInitialized(){
        this.eventbus.emit('walletConnectInitialized');
        this.isConnected = true;
    }
        
    init() {
        if (typeof window.ethereum !== 'undefined') {
            this.checkNetwork();
            this.checkStoredConnection();
            
            window.ethereum.on('accountsChanged', (accounts) => this.handleAccountsChanged(accounts));
            window.ethereum.on('chainChanged', this.networkChanged);
            window.ethereum.on('disconnect', () => this.handleDisconnect());
        } else {
            this.showMetaMaskInstallMessage();
        }
    }

    networkChanged(chainId) {
        console.log(chainId, "networkChanged");
    }
    async checkNetwork() {
        const chainId = await window.ethereum.request({ method: 'eth_chainId' });
        if (chainId !== this.targetNetwork) {
            try {
                await window.ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: this.networkParams[this.targetNetwork].chainId }],
                });
            } catch (switchError) {
                if (switchError.code === 4902) {
                    try {
                        await window.ethereum.request({
                            method: 'wallet_addEthereumChain',
                            params: [this.networkParams[this.targetNetwork]],
                        });
                    } catch (addError) {
                        console.error(this.t('walletConnect.networkAddFailed'), addError);
                        this.toast.error(this.t('walletConnect.networkAddFailed'));
                    }
                } else {
                    console.error(this.t('walletConnect.networkSwitchFailed'), switchError);
                    this.toast.error(this.t('walletConnect.networkSwitchFailed'));
                }
            }
        }
    }

    showMetaMaskInstallMessage() {
        this.toast.error(this.t('walletConnect.installMetaMask'));
    }

    async checkStoredConnection() {
        const storedAddress = localStorage.getItem('walletAddress');
        if (storedAddress) {
            try {
                const accounts = await window.ethereum.request({ method: 'eth_accounts' });
                if (accounts.length > 0 && accounts[0].toLowerCase() === storedAddress.toLowerCase()) {
                    this.walletAddress = storedAddress;
                } else {
                    this.disconnectWallet();
                }
            } catch (error) {
                console.error(this.t('walletConnect.checkStatusFailed'), error);
                this.disconnectWallet();
            }
        }
    }

    async toggleConnect() {
        if (this.store.state.isUserLoggedIn) {
            this.disconnectWallet();
        } else {
            try {
                const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                if(this.isAgentRoute){
                    const isAgent = await this.agentCheckMap(accounts[0]);
                    if(!isAgent){
                        this.toast.error(this.t('walletConnect.notAgent'));
                        return;
                    }
                }
                await this.bindUserAccount(accounts[0]);
            } catch (error) {
                console.error(this.t('walletConnect.connectFailed'), error);
                this.toast.error(this.t('walletConnect.connectFailed')+ error.message);
            }
        }
    }
    async createStoreByStoreManger(address) {
        try {
            const tx = await this.buyContract.methods.createStoreByStoreManger(address).send({ from: address });
            console.log("tx", tx);
            this.toast.success(this.t('walletConnect.createStoreSuccess'));
        } catch (error) {
            console.error(this.t('walletConnect.createStoreFailed'), error);
            this.toast.error(this.t('walletConnect.createStoreFailed')+ error.message);
        }
    }
    async agentCheckMap(address){
        console.log(this.buyContract, this.targetNetwork, this.web3, 'agentCheckMap');
        try {
        const userInfo = await this.buyContract.methods.getUserInfo(address).call();
        console.log("userInfo agentCheckMap", userInfo);
        return userInfo.isAgent; 
        }catch(e) {
            console.error(e, this.buyContract, this.targetNetwork, 'agentCheckMap');
            return false;
        }
    }
    
    async bindUserAccount(walletAddress) {
        if (this.isRequestPending) {
            this.toast.error(this.t('walletConnect.pendingRequest'));
            return;
        }
        let salt = new Date().getTime();
        const message = this.t('walletConnect.signMessage');
        let messageHash = Web3.utils.stringToHex(message);
    // if(window.ethereum.isTokenPocket) {
    //   let messageDigest = ethers.hashMessage(message);
      // let sign = await ethers.signMessage(messageDigest);
      let signature = await this.web3.eth.personal.sign(messageHash, walletAddress, salt.toString());
        this.setLoading(true); // Start loading
        this.isRequestPending = true; // Set request pending flag
        
        try {
            // const signature1 = await window.ethereum.request({
            //     method: 'personal_sign',
            //     params: [message, walletAddress]
            // });
// console.log(signature1, "signature1", signature, "signature");
            const inviteCode = localStorage.getItem('inviteCode');

            const result = await this.store.dispatch('bindUserAccount', { walletAddress, message, signature, inviteCode });

            if (result && result.success) {
                this.walletAddress = walletAddress;
                localStorage.setItem('walletAddress', walletAddress);
                console.log(this.isAgentRoute, "this.isAgentRoute");
                console.log(result.isAgent, "result.isAgent");
                if(this.isAgentRoute){
                    if(result.isAgent){
                        this.router.push({path: '/dashboard'});
                    } else {
                        this.toast.error(this.t('walletConnect.notAgentError'));
                        this.disconnectWallet(); // Clear login state
                    }
                } 
            } else {
                this.toast.error(result ? result.message : this.t('walletConnect.bindFailed'));
            }
        } catch (error) {
            console.error(this.t('walletConnect.signFailed'), error);
            this.toast.error(this.t('walletConnect.signFailed'));
        } finally {
            this.setLoading(false); // Stop loading
            this.isRequestPending = false; // Reset request pending flag
        }
    }

    disconnectWallet() {
        this.store.commit('LOGOUT');
        this.walletAddress = '';
        this.router.push('/');
    }

    handleAccountsChanged(accounts) {
        if (accounts.length === 0) {
            this.disconnectWallet();
        } else if (accounts[0] !== this.walletAddress) {
            this.bindUserAccount(accounts[0]);
        }
    }

    handleDisconnect() {
        this.disconnectWallet();
    }

    async buyPhone(id, num, inviteAddress, cb) {
        try {
            console.log(inviteAddress, "inviteAddress");
            if(id.length==0 || num.length==0) {
                this.setLoading(false);
                return cb(new Error(this.t('walletConnect.noProductSelected')), null);
            }
            this.setLoading(true);

            const walletAddress = this.store.state.walletAddress;
            if (!walletAddress) {
                this.setLoading(false);
                return cb(new Error(this.t('walletConnect.noWalletConnected')), null);
            }

            const chainId = await this.web3.eth.getChainId();
            if (parseInt(chainId, 10) !== parseInt(this.targetNetwork, 10)) {
                this.setLoading(false);
                console.log(parseInt(chainId, 10), "chainId");
                console.log(parseInt(this.targetNetwork, 10), "this.targetNetwork");
                return cb(new Error(this.t('walletConnect.incorrectNetwork')), null);
            }

            const userBalance = await this.usdtContract.methods.balanceOf(walletAddress).call();
            let totalPrice = 0;
            if(id.length > 1) {
                for(let i = 0; i < id.length; i++) {
                    console.log(id[i], "id[i]");
                    console.log(this.web3.utils.toHex(id[i]), "this.web3.utils.toHex(id[i])");
                    const {price, total, saleCount} = await this.buyContract.methods.getPhoneInfo(this.web3.utils.toHex(id[i])).call();
                    totalPrice += Number(price) * Number(num[i]);

                    if (total <= saleCount) {
                        this.setLoading(false);
                        return cb(new Error(this.t('walletConnect.productSoldOut')), null);
                    }
                }
            } else {
                console.log(id[0], "id[0]");
                console.log(this.web3.utils.toHex(id[0]), "this.web3.utils.toHex(id[0])");
                const {price, total, saleCount} = await this.buyContract.methods.getPhoneInfo(this.web3.utils.toHex(id[0])).call();
                totalPrice = Number(price) * Number(num[0]);

                if (total <= saleCount) {
                    this.setLoading(false);
                    return cb(new Error(this.t('walletConnect.productSoldOut')), null);
                }
            }
            if (userBalance < totalPrice) {
                this.setLoading(false);
                return cb(new Error(this.t('walletConnect.insufficientBalance')), null);
            }
            if(this.web3.utils.isAddress(inviteAddress)) { 
                const userInfo = await this.buyContract.methods.getUserInfo(inviteAddress).call();
                // 如果推荐人不是代理，邀请人必须购买手机 否则邀请地址换成管理员地址
                if(!userInfo.isAgent && !userInfo.isMainAgent) {
                    if(userInfo.buyPhoneNum == 0) {
                        inviteAddress = await this.buyContract.methods.managerAddress().call();
                    }
                } else {
                    // 如果推荐人是代理，判断是否为中间商，如果是中间商则判断当前用户购买数量是否大于等于中间商的购买数量
                    const agentInfo = await this.buyContract.methods.getAgentInfo(inviteAddress).call();
                    if(agentInfo.isStore) { 
                        if(num < this.storeThreshold) {
                            this.setLoading(false);
                            return cb(new Error(this.t('walletConnect.storeThresholdNotMet')), null);
                        }
                    }
                }
            } else {
                inviteAddress = await this.buyContract.methods.managerAddress().call();
            }
            const allowance = await this.usdtContract.methods.allowance(walletAddress, this.contractAddress).call();
            console.log(allowance, "allowance");
            if(allowance < totalPrice) {
                await this.usdtContract.methods.approve(this.contractAddress, totalPrice).send({ from: walletAddress });
            }

            id = id.map(d=> this.web3.utils.toHex(d));
            num = num.map(d=> this.web3.utils.toHex(d));
            // 监听 BuyPhone 事件
            console.log(walletAddress, this.web3.utils.toChecksumAddress(walletAddress), "walletAddress");
            this.buyContract.events.BuyPhone({
                filter: { buyer: this.web3.utils.toChecksumAddress(walletAddress) },
                fromBlock: 'latest'
            }, (error, event) => {
                this.setLoading(false);
                event.invite_address = inviteAddress;
                return cb(error, event);
            });
            let txhash = null; 
            // 执行购买合约方法
            if(id.length > 1) {
                txhash = await this.buyContract.methods.batchBuy(id, num, inviteAddress).send({ from: walletAddress });
                console.log(txhash, txhash.transactionHash, "txhash");
            } else {
                txhash = await this.buyContract.methods.buy(id[0], num[0], inviteAddress).send({ from: walletAddress });
                console.log(txhash, txhash.transactionHash, "txhash");
            }
            return cb(null, {returnValues: txhash, invite_address: inviteAddress});
        } catch (error) {
            console.error(this.t('walletConnect.purchaseFailed'), error, error.message);
            this.setLoading(false);
            return cb(error, null);
        } finally {
            this.setLoading(false);
        }
    }

    async getAgentInfo(address) {
        try {
            const agentInfo = await this.buyContract.methods.getAgentInfo(address).call();
            // console.log(agentInfo, "agentInfo");
            return agentInfo;
        } catch (error) {
            console.error(this.t('walletConnect.fetchAgentInfoFailed'), error);
            this.toast.error(this.t('walletConnect.fetchAgentInfoFailed'));
            throw error;
        }
    }

    async addAgent(agentAddress, fee) {
        try {
            const accounts = await this.web3.eth.getAccounts();
            await this.buyContract.methods.createAgent(agentAddress, fee).send({ from: accounts[0] });
            this.toast.success(this.t('walletConnect.addAgentSuccess'));
        } catch (error) {
            console.error(this.t('walletConnect.addAgentFailed'), error);
            this.toast.error(this.t('walletConnect.addAgentFailed'));
            throw error;
        }
    }

    async gainUnReward() {
        try {
            const accounts = await this.web3.eth.getAccounts();
            const txhash = await this.buyContract.methods.gainUnReward().send({ from: accounts[0] });
            console.log(txhash, "txhash");
            this.toast.success(this.t('walletConnect.rewardClaimed'));
        } catch (error) {
            console.error(this.t('walletConnect.rewardClaimFailed'), error);
            this.toast.error(this.t('walletConnect.rewardClaimFailed'));
            throw error;
        }
    }

    async getPhoneInfo(id) {
        try {
            const phoneInfo = await this.buyContract.methods.getPhoneInfo(id).call();
            return phoneInfo;
        } catch (error) {
            console.error(this.t('walletConnect.fetchPhoneInfoFailed'), error);
            this.toast.error(this.t('walletConnect.fetchPhoneInfoFailed'));
            throw error;
        }
    }

    async getDirectUser() {
        try {
            const walletAddress = this.store.state.walletAddress;
            const directList = await this.buyContract.methods.getDirectAddressMap(walletAddress).call();
            return directList;
        } catch(error) {
            console.error("getDirectUser failed", error);
            throw error; 
        }
    }

    async getUserInfo(address) {
        try {
            const userInfo = await this.buyContract.methods.getUserInfo(address).call();
            return userInfo;
        } catch (error) {
            console.error(this.t('walletConnect.fetchUserInfoFailed'), error);
            this.toast.error(this.t('walletConnect.fetchUserInfoFailed'));
            throw error;
        }
    }

    async updateAgentEarnings(address, earnings) {
        try {
            const accounts = await this.web3.eth.getAccounts();
            const txhash = await this.buyContract.methods.updateAgentFee(address, earnings).send({ from: accounts[0] });
            console.log(txhash, "txhash");
            this.toast.success(this.t('walletConnect.updateAgentEarningsSuccess'));
        } catch (error) {
            console.error(this.t('walletConnect.updateAgentEarningsFailed'), error);
            this.toast.error(this.t('walletConnect.updateAgentEarningsFailed'));
            throw error;
        }
    }

    async getMainAgentsCount() {
        try {
            const count = await this.buyContract.methods.getMainAgentsCount().call();
            return count;
        } catch (error) {
            console.error(this.t('walletConnect.fetchMainAgentsCountFailed'), error);
            this.toast.error(this.t('walletConnect.fetchMainAgentsCountFailed'));
            throw error;
        }
    }
}

export default WalletConnect;